<template>
    <div class="app-wrapper" :class="classObj" :style="{ '--current-color': theme }">
        <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
        <sidebar class="sidebar-container" v-if="!sidebar.hide" />
        <navbar ref="navbarcomponent" class="navbarstyle" />
        <div class="main-container" style="padding-top: 64px;">
            <app-main />
        </div>
        <div class="sidermenulist">
            <div class="sidermenuli"  @click="gotoNotice()">
                <div class="kfu">
                    <div class="sidermenuli_iconbox">
                        <svgStyle :color="'#E82511'" :width="24" :height="24" :url="'#icon-xiaoxizhongxin1'"></svgStyle>
                    </div>
                    <div class="unreadnum" v-if="imnum>0">{{ imnum }}</div>
                    <div class="label">IM消息</div>
                </div>
            </div>
            <div class="sidermenuli"  @click="openCsChat()">
                <div class="notice">
                    
                    <div class="sidermenuli_iconbox">
                        <svgStyle :color="'#E82511'" :width="24" :height="24" :url="'#icon-zaixiankefu1'"></svgStyle>
                    </div>
                    <div class="unreadnum" v-if="csnum>0">{{ csnum }}</div>
                    <div class="label">平台客服</div>
                </div>
            </div>
        </div>
        <!-- 客服聊天框登录-->
        <chatServer v-if="chatServerShow" v-model="chatServerShow"></chatServer>
    </div>
</template>
<script>
import { AppMain, Navbar, Sidebar, TagsView } from './components';
import chatServer from '@/components/chatServer'
import { mapState } from 'vuex';
import variables from '@/assets/styles/variables.module.scss';
import ResizeMixin from './mixin/ResizeHandler.js';
import { getlistMemberSum } from '@/api/base.js';
export default {
    name: 'Layout',
    components: {
        AppMain, Navbar, Sidebar, TagsView, chatServer
    },
    mixins: [ResizeMixin],
    computed: {
        ...mapState({
            theme: (state) => state.settings.theme,
            sideTheme: (state) => state.settings.sideTheme,
            sidebar: (state) => state.app.sidebar,
            device: (state) => state.app.device,
            needTagsView: (state) => state.settings.tagsView,
            fixedHeader: (state) => state.settings.fixedHeader,
            txImShow: (state) => state.user.txImShow
        }),
        classObj() {
            return {
                hideSidebar: !this.sidebar.opened,
                openSidebar: this.sidebar.opened,
                withoutAnimation: this.sidebar.withoutAnimation,
                mobile: this.device === 'mobile'
            }
        },
        variables() {
            return variables
        }
    },
    data() {
        return {
            fixedHeader: true,
            needTagsView: true,
            chatServerShow: false,
            timer: null,
            imnum: 0,
            csnum: 0
        }
    },
    mounted() {
        this.getlistMemberSumData();
        clearInterval(this.timer);
        this.timer = setInterval(() => {
            this.getlistMemberSumData();
        }, 1000);
      
    },
    methods: {
        openCsChat() {
            this.chatServerShow = true;
        },
        gotoNotice() {
            this.$router.push({ path: '/message/onlineservice' });
        },
        getlistMemberSumData() {
            getlistMemberSum(this.$store.state.user.shopid,1).then(res => {
                if (res.code === 0) {
                    if(res.data){
                        console.log(res.data)
                        this.imnum = res.data.unSum;
                    }else{
                        this.imnum = 0;
                    }
                }
            })
            getlistMemberSum(this.$store.state.user.shopid,3).then(res => {
                if (res.code === 0) {
                    if(res.data){
                        this.csnum = res.data.unSum;
                    }else{
                        this.csnum = 0;
                    }
                }
            })
        }
    },
    unmounted() {
        clearInterval(this.timer);
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/mixin.scss';
@import '@/assets/styles/variables.module.scss';

.fixed-header {
    // position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    // width: calc(100% - #{$base-sidebar-width});
    transition: width 0.28s;
}

.hideSidebar .fixed-header {
    width: calc(100% - 54px);
}

.sidebarHide .fixed-header {
    width: calc(100%);
}

.mobile .fixed-header {
    width: 100%;
}

.app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    .sidermenulist {
        width: 48px;
        height: 152px;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 4px rgba(242, 169, 162, 0.16);
        border-radius: 24px;
        border: 1px solid #FFE2E2;
        padding: 12px 3px 16px 3px;
        position: fixed;
        right: 0;
        top: 40%;
        z-index: 999;

        .sidermenuli {
            // width: 36px;
            margin: 0 auto 16px auto;
            cursor: pointer;

            .kfu,
            .notice {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }

            .kfu,
            .notice {
                position: relative;
                .unreadnum {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 12px;
                    height: 12px;
                    background: #E82511;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 8px;
                    color: #fff;
                }

            }


            .label {
                height: 14px;
                font-family: 'AlibabaPuHuiTi-Medium';
                font-size: 10px;
                color: rgba(0, 0, 0, 0.85);
                line-height: 14px;
                margin-top: 4px;
            }

            .sidermenuli_iconbox {
                width: 36px;
                height: 36px;
                background: rgba(232, 37, 17, 0.08);
                border-radius: 50%;
                text-align: center;
                line-height: 36px;
                display: flex;
                align-items: center;
                justify-content: center;

                .icon-backtop {
                    font-size: 22px;
                }
            }

        }

        .kfu:hover,
        .notice:hover {
            .sidermenuli_iconbox {
                background: #E82511;

                :deep(svg) {
                    fill: #fff !important;
                }
            }
        }
    }


    &.mobile.openSidebar {
        position: fixed;
        top: 0;
    }
}

.navbarstyle {
    z-index: 1002;
    position: fixed;
    width: 100%;
    top: 0;
    box-shadow: 0px 4px 4px 2px rgba(0, 0, 0, 0.04);
}
</style>
